export default "__VITE_ASSET__DdhjpmiC__"